import i18next from '@i18n';
import { getContextualDateTime, getFriendlyDateTime } from './dateUtils';
import i18n from '@i18n';

declare global {
    interface Date {
        toLocalRegularDateTime(): string;
        toLocalInputDate(): string;
        toLocalMediumDateTime(): string;
    }
    interface String {
        extractEmails(): string[];
        toLocalRegularDateTime(): string;
        toCamelCase(): string;
        toLocalInputDate(): string;
        toLocalInputDateTime(): string;
        getNameInitials(): string;
        toCountryDisplayName(): string | undefined;
        toContextualDateTime(): string;
        toFriendlyDateTime(): string;
        toInt(): number;
        toDate: () => Date;
    }
    interface Number {
        toCurrencyString(lang: string, currency: string): string;
        toShorthand(): string;
    }
}

String.prototype.toContextualDateTime = function (): string {
    return getContextualDateTime(this);
};

String.prototype.toFriendlyDateTime = function (): string {
    return getFriendlyDateTime(this);
};

String.prototype.toInt = function (): number {
    return parseInt(this);
};

String.prototype.toDate = function (): Date {
    return new Date(this);
};

Date.prototype.toLocalRegularDateTime = function (): string {
    return this.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
};

Date.prototype.toLocalMediumDateTime = function (): string {
    return this.toLocaleString(i18n.language, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

Date.prototype.toLocalInputDate = function (): string {
    return this.toISOString().split('T')[0];
};

String.prototype.toLocalRegularDateTime = function (): string {
    return new Date(this).toLocalRegularDateTime();
};

String.prototype.extractEmails = function (): string[] {
    const regex = /[\w.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/g;
    return this.match(regex) || [];
};

String.prototype.toCamelCase = function (): string {
    return this.toLowerCase().replace(/\b[a-z]/g, char => char.toUpperCase());
};

String.prototype.toLocalInputDate = function (): string {
    return new Date(this).toISOString().split('T')[0];
};

String.prototype.toLocalInputDateTime = function (): string {
    return new Date(this).toISOString().slice(0, 16);
};

String.prototype.getNameInitials = function (): string {
    return this.split(' ')
        .slice(0, 2)
        .map(name => name[0])
        .join('');
};

String.prototype.toCountryDisplayName = function (): string | undefined {
    try {
        return new Intl.DisplayNames([i18next.language], { type: 'region' }).of(
            this,
        );
    } catch (error) {
        if (error instanceof RangeError) {
            return undefined;
        }
        throw error;
    }
};

Number.prototype.toCurrencyString = function (
    lang: string,
    currency: string,
): string {
    return this.toLocaleString(lang, {
        currency: currency,
        style: 'currency',
    });
};

Number.prototype.toShorthand = function (): string {
    const formatter = new Intl.NumberFormat(undefined, {
        notation: 'compact',
        compactDisplay: 'short',
    });
    return formatter.format(this);
};

export {};
